const $ = jQuery.noConflict();

class Transitions {
    makeElTransition() {
        const el = $('.transition-element');
        function checkVisibility() {
            if ($(window).scrollTop() + $(window).height() > $(this).offset().top - 150) {
                $(this).addClass('visible');
            }
        }

        el.each(checkVisibility);
    }
}

export default new Transitions();
